import slider from './slider';
import transition from './transition';

export default class topManager {
    constructor(manager) {

        //manager
        this.manager = manager;
        this.slider = new slider(this.manager,this); //スライダー動作
        this.transition = new transition(this.manager,this); //ページ遷移動作

        //dom slider
        this.$slideList = document.querySelectorAll('#p-kv__image ul li');
        this.$slidePager = document.querySelectorAll('#p-kv__pager ul li');

        //dom transition
        this.$kv = document.querySelectorAll('#p-kv');
        this.$copyList = document.querySelectorAll('#p-kv__copy>*');

        //dom header
        this.$headerNavi = document.getElementById("l-header__navi");

        this.status = {
            slideTime:0,
            current:0,
            next:0,
            max:this.$slideList.length-1,
            motion:false,
        }

        // 全体のボタン関係の色の設定（スライダーによって変更）
        this.colorArray = {
            logoColor: ['white','white','white','white'],
            snsColor: ['white','white','white','white'],
            footerColor: ['white','white','white','white'],
            menuColor: ['white','white','white','white'],
            headerOpacity: [0,0,0,0]
        };

        //最初のコピーのスタート位置です
        this.randomArray = {
            x: [-100,-100,-50,-25,0,25,45,90,100,120],
            y: [85,55,30,15,5,-5,-15,-45,-75,-100]
        };

    }
    init(){

        // ------------ 左のスクロールを促すアイコンを消します
        this.manager.scrollIcon.hide();
        // ------------ spの時fixedフッターを表示
        if(this.manager.param.displayType == 'sp'){
            TweenMax.to('#l-footer', .6 ,{
                opacity:1,
                ease: Power2.easeOut,
            });
        }
        // ------------ TOPではHeaderを必ず表示
        TweenMax.to(this.$headerNavi, .6 ,{
            opacity:1,
            ease: Power2.easeOut,
        });

        this.slider.init();
        // this.transition.init();
        // this.transition.in();
        this.transition.fadeInPhoto();
        this.manager.color.set(this.colorArray.logoColor[0],this.colorArray.snsColor[0],this.colorArray.footerColor[0],this.colorArray.menuColor[0],this.colorArray.headerOpacity[0]);

    }
    show(){// 画面遷移時に使用
    }
    out(){// 画面遷移時に使用
    }
    render(){
        this.slider.render();
    }
    resize(displayType){
    }
}